import { render } from "./FfrList.vue?vue&type=template&id=63505931&scoped=true"
import script from "./FfrList.vue?vue&type=script&lang=js"
export * from "./FfrList.vue?vue&type=script&lang=js"

import "./FfrList.vue?vue&type=style&index=0&id=63505931&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63505931"]])

export default __exports__